var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClippathgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 223,
    viewBox: "0 0 214 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_731_8657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 214,
    height: 223
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_35_901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M213.14 0H0V222.819H213.14V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_731_8657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M92.6259 91.9402C86.4052 94.1297 81.3312 99.3477 79.3161 105.627C79.0537 106.445 78.8279 107.303 78.2908 107.974C77.7538 108.644 76.7947 109.07 76.0175 108.705C75.6041 108.51 75.3098 108.128 75.0866 107.73C74.3977 106.5 74.2556 105.045 74.1966 103.637C74.053 100.223 74.3124 96.789 75.0027 93.442C75.7168 89.9806 81.3136 76.5209 95.2611 76.124C95.4915 80.8447 94.4009 85.5185 93.3177 90.1189C93.0622 91.2036 92.7848 92.334 92.6259 91.9402Z",
    fill: "#9746FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M117.016 100.617C120.314 106.328 120.769 113.592 118.212 119.671C117.879 120.462 117.491 121.261 117.462 122.12C117.434 122.978 117.885 123.926 118.712 124.155C119.153 124.276 119.625 124.178 120.054 124.021C121.377 123.536 122.432 122.524 123.393 121.493C125.725 118.994 127.763 116.219 129.417 113.229C131.128 110.136 135.64 96.2752 125.31 86.895C122.063 90.3289 119.848 94.587 117.676 98.7842C117.164 99.7741 116.639 100.813 117.016 100.617V100.617Z",
    fill: "#9746FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M92.2369 96.5892C89.2735 102.925 85.7133 108.96 82.1588 114.984C76.6413 124.335 71.1242 133.686 65.8601 142.293C58.4827 137.491 50.0251 133.966 41.2245 133.773C32.4238 133.58 23.2789 137.102 18.0373 144.174C12.7957 151.246 12.3789 161.969 18.1628 168.605C12.33 167.7 6.29543 170.994 3.16633 175.999C0.037224 181.004 -0.402491 187.395 1.15643 193.088C3.24112 200.704 8.84464 207.278 16.0338 210.542C23.2229 213.806 29.2293 213.699 36.335 210.257C37.8578 215.206 41.506 216.931 44.77 218.616C50.0311 221.334 56.1105 222.912 61.9128 221.729C67.7148 220.547 73.0721 216.164 74.2169 210.354C77.461 216.863 84.8422 220.238 91.9693 221.682C96.7197 222.644 101.692 222.963 106.385 221.748C115.732 219.327 122.974 210.355 123.369 200.708C133.427 201.027 139.115 196.02 140.894 186.825C142.626 177.87 133.592 169.676 125.585 169.378C128.635 167.842 132.835 161.115 127.16 151.824C123.277 145.468 114.093 141.911 107.015 142.47C108.882 129.765 110.824 121.905 115.49 104.598C108.35 100.885 101.87 99.556 92.2373 96.5892H92.2369Z",
    fill: "white",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.0884 168.638C21.0728 170.36 23.0556 173.575 26.2065 174.97C27.7181 175.639 29.3875 175.836 31.0156 176.123",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.338 210.714C34.1244 204.472 35.3594 197.126 39.4919 191.951",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M74.2853 211.021C75.1023 206.833 75.1689 202.499 74.4819 198.287",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M125.651 169.725C122.813 169.653 119.961 170.652 117.789 172.479",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M123.249 200.895C121.244 200.351 119.281 199.649 117.385 198.8",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M97.0947 126.294C90.9451 138.994 88.0039 153.054 81.8836 165.769",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M75.8554 138.215C71.2655 146.611 66.4813 154.901 61.5088 163.076",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M147.509 23.4667C146.562 35.3202 143.721 47.0684 139.805 58.3281C134.017 74.9695 127.125 92.1334 115.598 107.486C107.736 105.975 92.5037 98.8644 89.7376 98.218C96.6753 61.1843 107.097 37.8795 125.463 16.2772C127.399 13.9997 129.425 11.7372 131.544 9.4823C134.927 5.88567 138.606 2.39803 142.887 0.323487C144.303 0.0679273 145.724 1.02252 146.449 2.27025C147.171 3.51799 147.348 4.99873 147.475 6.43437C147.979 12.1093 147.96 17.7993 147.509 23.4667Z",
    fill: "#E3E3FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M111.34 82.3194C110.204 81.8824 109.008 82.9283 108.414 83.9907C104.87 90.3309 97.6641 107.262 94.6688 115.615C94.4061 116.348 93.6109 117.909 95.5159 118.658C96.9869 119.237 97.7382 117.753 98.6417 115.698C101.65 108.855 104.847 101.449 107.855 94.6066C109.57 90.7059 113.239 83.2703 111.341 82.3194H111.34Z",
    fill: "#9746FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M130.567 23.9627C129.059 24.0856 127.537 24.4697 126.263 25.2864C124.815 26.215 123.842 27.739 123.181 29.3276C122.698 30.4851 122.353 31.734 122.466 32.9828C122.541 33.8029 123.113 39.0832 129.664 39.8815C131.28 40.0784 137.302 40.6038 138.945 34.5643C139.975 30.7775 137.696 23.3821 130.567 23.9627Z",
    fill: "white",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M130.638 26.2839C129.568 26.3711 128.488 26.6439 127.584 27.2231C126.556 27.8823 125.866 28.9635 125.396 30.091C125.054 30.9125 124.809 31.7987 124.889 32.6849C124.942 33.2671 125.349 37.014 129.998 37.5808C131.144 37.7206 135.418 38.0934 136.584 33.8075C137.315 31.12 135.698 25.872 130.638 26.2839Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M147.509 23.4667C139.485 21.0426 132.664 18.5509 125.463 16.2772C127.399 13.9997 129.425 11.7372 131.544 9.4823C134.927 5.88567 138.606 2.39803 142.887 0.323487C144.303 0.0679274 145.724 1.02252 146.449 2.27025C147.171 3.51799 147.348 4.99873 147.475 6.43437C147.979 12.1093 147.96 17.7993 147.509 23.4667Z",
    fill: "#9746FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M157.896 25.5683C158.514 24.7373 158.924 23.711 158.838 22.6793C158.752 21.6477 158.097 20.6341 157.116 20.3041C156.121 19.9696 155.046 20.3594 154.058 20.7141C151.16 21.7559 148.103 22.5621 145.621 24.3852C145.016 24.8298 144.443 25.3405 144.052 25.9821C143.531 26.8374 143.369 27.8687 143.378 28.8703C143.385 29.6839 143.498 30.4968 143.713 31.2816C144.583 34.4558 147.051 36.9595 149.761 38.8266C151.386 36.5141 153.035 34.1562 153.9 31.4661C154.229 30.4453 154.443 29.3829 154.884 28.4054C155.324 27.4279 156.655 27.2373 157.896 25.5683Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M148.616 31.3668C148.44 31.4731 148.285 31.611 148.162 31.7764C147.85 32.1966 147.658 32.7175 147.69 33.2399C147.721 33.7619 147.995 34.2779 148.444 34.5458C148.864 34.7961 149.384 34.8123 149.87 34.683C149.783 36.2029 149.766 37.7268 149.641 39.374C150.349 40.1821 151.319 40.7567 152.368 40.9897C153.417 41.2227 154.539 41.1126 155.631 40.6477C155.734 39.5947 155.797 38.5375 155.808 37.4453C157.145 36.9849 158.513 36.2532 159.108 34.9709C159.53 34.0599 159.496 33.0095 159.405 32.0094C159.179 29.5203 158.654 27.0587 157.831 24.7737C156.959 24.8721 156.077 24.9725 155.252 25.2743C154.428 25.5761 152.467 26.2014 152.197 28.6097C151.958 30.7365 152.363 32.3375 152.292 32.4318C152.225 32.5202 151.042 32.6235 150.756 32.6028C150.452 31.4746 149.695 30.7173 148.616 31.3668Z",
    fill: "white",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M157.144 28.9274C157.461 29.6771 157.777 30.4269 158.163 31.2124C157.786 31.4086 157.372 31.5307 156.948 31.5694",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M153.286 37.4176C154.177 37.5923 155.105 37.5795 155.991 37.3807",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M157.007 43.0428C158.183 50.8806 157.925 75.1404 157.902 81.7842C149.965 83.0801 143.662 82.8542 135.809 81.1216C135.531 81.0604 135.239 80.9897 135.032 80.7947C134.819 80.5932 134.732 80.2918 134.697 80.0002C134.565 78.8776 135.079 77.7907 135.582 76.7783C141.3 65.2649 147.158 54.2638 157.007 43.0428Z",
    fill: "#00C2FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M146.376 40.6222C147.172 39.8209 147.291 39.3715 148.11 38.3981C151.122 38.8175 153.945 39.2241 157.289 39.9852C156.905 40.9879 157.087 41.8549 156.88 43.0429C152.369 42.1695 150.29 41.6335 146.376 40.6222Z",
    fill: "#9746FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M155.087 136.568C154.089 138.706 153.09 140.844 152.02 143.075C156.695 146.329 161.887 148.838 167.391 150.491C166.496 148.66 165.742 146.761 165.137 144.815C164.928 144.141 164.734 143.441 164.82 142.741C164.92 141.915 165.403 141.16 165.424 140.328C162.411 138.955 159.452 137.465 155.087 136.568Z",
    fill: "white",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M138.515 110.282C135.879 111.164 133.303 112.227 130.812 113.461C132.54 118.613 134.269 123.764 135.997 128.916C136.595 126.6 137.193 124.284 137.791 121.967C137.991 121.193 138.197 120.404 138.624 119.726C139.051 119.049 139.742 118.49 140.54 118.427C140.161 115.463 139.577 112.526 138.515 110.281L138.515 110.282Z",
    fill: "white",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M131.363 81.2036C129.917 83.66 129.439 86.67 130.054 89.4537C130.668 92.2374 132.368 94.7663 134.714 96.3861C136.777 97.8101 139.247 98.5155 141.703 99.0154C148.088 100.315 154.652 100.375 161.168 100.43C162.823 100.444 164.478 100.459 166.199 100.66C162.041 112.592 157.764 124.483 153.307 136.871C157.912 139.609 163.221 141.149 168.606 141.165C175.31 127.165 180.697 112.536 184.674 97.532C185.223 95.4639 185.738 93.233 184.992 91.2276C184.247 89.2282 182.377 87.8576 180.434 86.9755C178.32 86.0157 176.038 85.4974 173.773 84.9852C168.406 83.7712 163.039 82.5573 157.302 81.5366C147.891 81.7737 138.467 81.4678 131.364 81.204L131.363 81.2036Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M174.837 86.2608C182.858 85.3731 187.175 90.526 187.769 95.7014C187.882 96.6936 187.86 97.7121 187.585 98.6723C187.273 99.763 186.643 100.747 185.86 101.568C184.206 103.302 181.941 104.294 179.74 105.242C166.775 110.827 153.81 116.412 140.883 122.096C139.403 117.798 138.108 113.435 136.897 109.198C142.792 105.097 150.821 100.94 156.948 97.608C164.74 94.3034 167.923 91.1604 174.837 86.2608Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M100.077 59.0463C98.8036 59.5822 97.2932 59.6303 96.2323 60.5146C95.6125 61.031 95.2296 61.7706 94.8718 62.4933C94.3644 63.5178 93.8661 64.5795 93.7687 65.7186C93.6714 66.8578 94.0529 68.1055 94.9894 68.9124C95.1127 69.4276 95.2371 69.9489 95.2303 70.4784C95.225 70.8945 95.1401 71.3199 95.2521 71.7205C95.2713 71.7897 95.298 71.8592 95.3483 71.91C95.4712 72.0336 95.6847 71.9968 95.8301 71.9013C96.1075 71.719 96.2405 71.3876 96.3533 71.0752C96.6964 70.1263 97.0057 69.1585 97.2192 68.3979C97.7709 66.9968 98.5695 65.7029 99.1129 64.2988C99.6564 62.8947 99.9307 61.3001 100.077 59.0463Z",
    fill: "white",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M146.242 40.6227C144.879 41.9802 143.448 43.2689 141.76 44.6786C127.466 48.6773 113.372 53.3898 99.4586 58.619C98.5965 62.0585 97.8193 65.5195 97.3116 68.7027C110.944 65.8303 124.528 62.7256 137.65 59.2151C135 66.5556 132.488 73.9458 130.063 81.7772C133.826 82.8288 137.416 84.411 141.089 86.2604C143.251 84.7508 145.433 83.2238 147.208 81.2733C151.766 76.2647 153.071 69.1872 154.189 62.508C155.365 55.4809 155.978 50.1446 157.007 43.043C154.175 42.6672 149.755 41.5525 146.242 40.6223L146.242 40.6227Z",
    fill: "#9746FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M150.246 74.5369C147.29 76.8734 144.165 79.2192 140.488 80.0404C140.721 81.6955 140.954 83.351 141.187 85.0062",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M151.705 100.149C156.417 100.369 161.129 100.589 165.896 100.786C164.735 105.074 163.374 109.308 161.82 113.47",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M177.465 85.7822C180.249 86.5621 183.167 87.8583 184.488 90.4297C185.511 92.4223 185.369 94.8069 184.954 97.0081C184.49 99.4742 183.716 101.881 182.655 104.156",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M11.8858 123.9C13.1016 123.148 14.317 122.395 15.5328 121.643",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M161.249 187.009C161.866 188.37 162.482 189.731 163.098 191.092C163.169 191.25 163.29 191.436 163.461 191.409C163.632 191.382 163.509 191.03 161.249 187.009Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M70.2305 52.9955C66.8898 47.4393 62.6235 42.4999 56.8523 39.1704C53.2636 37.1001 47.9915 38.3436 45.5693 41.705C43.2152 44.9717 43.8244 47.3183 45.5769 50.9435C43.1013 47.3239 39.0834 44.264 34.7189 44.6898C34.071 44.7529 33.4178 44.8969 32.8582 45.2298C31.5906 45.9841 31.0378 47.5911 31.1302 49.0636C31.2227 50.5361 31.8454 51.9154 33.6546 52.9083C49.7395 52.9083 50.8666 52.9959 70.2309 52.9959L70.2305 52.9955Z",
    fill: "#E3E3FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M212.533 141.438C212.788 138.702 213.423 134.617 211.683 132.491C209.783 130.169 206.136 129.901 203.443 131.223C200.751 132.544 199.25 135.005 197.838 137.652C198.868 135.8 199.109 133.814 199.254 131.7C199.445 128.92 198.354 125.587 195.65 124.911C194.496 124.623 193.273 124.893 192.16 125.313C188.811 126.576 186.086 129.153 184.044 132.093C182.002 135.033 179.933 139.004 178.629 141.836C191.31 141.836 197.877 141.438 212.533 141.438L212.533 141.438Z",
    fill: "#E3E3FF",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M189.513 161.804C189.028 161.738 188.514 161.973 188.246 162.383C187.978 162.793 187.97 163.357 188.225 163.776C188.679 164.52 189.925 164.555 190.441 163.851C190.957 163.148 190.583 161.948 189.514 161.803L189.513 161.804Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M57.8934 89.8491C57.5465 89.8022 57.1797 89.9698 56.9884 90.2629C56.7971 90.5557 56.7907 90.9589 56.973 91.2577C57.2977 91.7899 58.1876 91.8147 58.5559 91.3118C58.9242 90.809 58.657 89.9521 57.8934 89.8488V89.8491Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M195.857 63.4984C195.51 63.4515 195.143 63.6191 194.952 63.9122C194.76 64.2054 194.754 64.6082 194.936 64.907C195.261 65.4392 196.151 65.464 196.519 64.9611C196.887 64.4583 196.62 63.6018 195.857 63.4984Z",
    fill: "#475569"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClippathgroup);
export default __webpack_public_path__ + "static/media/Clip path group.3e15b02035042319db723fd92692cb58.svg";
export { ForwardRef as ReactComponent };